import { useState, useEffect } from 'react';
import { LOCAL_STORAGE_KEY } from '../utils/functions';

export function useLocalStorage(key, initialValue) {
  const storageKey = `${LOCAL_STORAGE_KEY}${key}`;

  const getStoredValue = () => {
    const stored = localStorage.getItem(storageKey);

    if (stored) {
      try {
        return JSON.parse(stored);
      } catch {
        return initialValue;
      }
    }

    return initialValue;
  };

  const [state, setState] = useState(getStoredValue);

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(state));
  }, [state, storageKey]);

  return [state, setState];
}
